import React from 'react';
export function HeroSection() {
  return <section aria-label="Presentación del ProfePack" className="bg-brand-dark text-white md:pt-20 pb-16 md:pb-24 px-4 relative pt-[10px]" data-id="element-126">
      <div className="max-w-5xl mx-auto relative z-10 w-full flex flex-col items-center text-center" data-id="element-127">
        <div className="flex flex-col items-center w-full" data-id="element-128">
          <div className="flex items-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4 md:mb-8" data-id="element-129">
            <span className="text-xl" aria-hidden="true" data-id="element-130">
              🌟
            </span>{' '}
            PROFEPACK
          </div>

          <h1 className="sm:text-4xl md:text-7xl lg:text-8xl tracking-tight px-2 text-[40px] font-[900] font-sans pl-[0px] pr-[0px] mt-[-20px] mb-[-20px] leading-[0.95]" data-id="element-131">
            Todo tu año de Sociales
            <br data-id="element-132" />
            <span className="text-brand-accent" data-id="element-133">resuelto.</span>
          </h1>
        </div>

        <div className="w-full max-w-[220px] sm:max-w-xs md:max-w-lg mx-auto relative mt-6 md:mt-12 mb-6 md:mb-12" data-id="element-134">
          <img src="https://cdn.magicpatterns.com/uploads/4RNMGryCsfyVfk5DBR6qtW/Sin_titulo_(420_x_420_px)_(2).png" alt="MegaPack Ciencias Sociales Lista — 6 tomos completos para docentes de primaria" className="w-full h-auto object-contain relative z-10 mt-[-5px] mb-[-10px]" loading="eager" decoding="sync" fetchPriority="high" width={420} height={420} data-id="element-135" />
        </div>

        <div className="flex flex-col items-center w-full max-w-3xl" data-id="element-136">
          <p className="text-lg sm:text-xl md:text-3xl text-brand-accent font-heading font-bold md:mb-6 px-2 mb-[5px]" data-id="element-137">
            "Listo para usar. Sin buscar más."
          </p>

          <p className="text-base md:text-xl text-white/80 md:mb-10 leading-relaxed px-2 mb-[10px]" data-id="element-138">
            El sistema que usan{' '}
            <span className="text-white font-bold" data-id="element-139">
              +1.500 docentes de Ciencias Sociales de primaria en Argentina
            </span>{' '}
            para planificar todo el año en una tarde — sin improvisar, sin
            buscar y sin perder domingos.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-6 md:mb-10 w-full px-2" data-id="element-140">
            <span className="text-[10px] md:text-xs font-medium border border-brand-border bg-brand-card px-2 md:px-3 py-1 md:py-1.5 rounded-full text-white/90 whitespace-nowrap" data-id="element-141">
              📄 100% PDF
            </span>
            <span className="text-[10px] md:text-xs font-medium border border-brand-border bg-brand-card px-2 md:px-3 py-1 md:py-1.5 rounded-full text-white/90 whitespace-nowrap" data-id="element-142">
              ⚡ Acceso inmediato
            </span>
            <span className="text-[10px] md:text-xs font-medium border border-brand-border bg-brand-card px-2 md:px-3 py-1 md:py-1.5 rounded-full text-white/90 whitespace-nowrap" data-id="element-143">
              🇦🇷 Currículo argentino
            </span>
            <span className="text-[10px] md:text-xs font-medium border border-brand-border bg-brand-card px-2 md:px-3 py-1 md:py-1.5 rounded-full text-white/90 whitespace-nowrap" data-id="element-144">
              🏫 1° a 6° Grado
            </span>
          </div>

          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })} className="w-auto bg-brand-accent hover:bg-brand-accent-dim active:scale-95 text-brand-dark font-black text-[15px] sm:text-xl md:text-3xl py-5 md:py-6 px-6 sm:px-10 md:px-14 rounded-2xl transition-colors flex items-center justify-center md:mb-8 mx-4 sm:mx-0 mb-[20px] whitespace-nowrap" data-id="element-145">
            → QUIERO MI PROFEPACK SOCIALES AHORA
          </button>

          <div className="flex flex-wrap justify-center gap-x-4 md:gap-x-8 gap-y-2 text-xs md:text-sm text-white/70 font-medium" data-id="element-146">
            <span data-id="element-147">🛡️ Garantía 7 días sin preguntas</span>
            <span data-id="element-148">🔒 Pago 100% seguro</span>
            <span data-id="element-149">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="mt-12 md:mt-24 w-full grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-5 md:p-8" data-id="element-150">
          <div className="text-center" data-id="element-151">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-152">
              +1.500
            </div>
            <div className="text-xs md:text-sm text-white/80 font-medium uppercase tracking-wider" data-id="element-153">
              docentes confían
            </div>
          </div>
          <div className="text-center" data-id="element-154">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-155">
              6
            </div>
            <div className="text-xs md:text-sm text-white/80 font-medium uppercase tracking-wider" data-id="element-156">
              Tomos completamente listos
            </div>
          </div>
          <div className="text-center" data-id="element-157">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-158">
              4.9/5 ⭐
            </div>
            <div className="text-xs md:text-sm text-white/80 font-medium uppercase tracking-wider" data-id="element-159">
              calificación
            </div>
          </div>
          <div className="text-center" data-id="element-160">
            <div className="text-2xl md:text-4xl font-heading font-bold text-brand-accent mb-1" data-id="element-161">
              🇦🇷
            </div>
            <div className="text-xs md:text-sm text-white/80 font-medium uppercase tracking-wider" data-id="element-162">
              Todo el país — primaria
            </div>
          </div>
        </div>

        {/* Hero Testimonials */}
        <div className="mt-8 md:mt-12 w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-163">
          {[{
          initials: 'MG',
          name: 'Mariela G.',
          loc: 'Córdoba | Primaria',
          quote: 'Organicé todo el año de Sociales en una tarde'
        }, {
          initials: 'LP',
          name: 'Laura P.',
          loc: 'Rosario | Primaria',
          quote: 'Mis clases por fin tienen estructura y sentido'
        }, {
          initials: 'RM',
          name: 'Roberto M.',
          loc: 'Buenos Aires | Primaria',
          quote: 'Nunca más llegué sin material a clase'
        }].map((test, i) => <div key={i} className="bg-brand-card border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-6 text-left" data-id="element-164">
              <div className="flex items-center gap-3 mb-3" data-id="element-165">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-sm md:text-base" aria-hidden="true" data-id="element-166">
                  {test.initials}
                </div>
                <span className="text-brand-accent text-sm" aria-label="5 estrellas" data-id="element-167">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <p className="text-white/90 font-medium italic mb-3 leading-relaxed text-sm md:text-base" data-id="element-168">
                "{test.quote}"
              </p>
              <div className="text-[10px] md:text-xs text-white/80 uppercase tracking-wider font-bold" data-id="element-169">
                — {test.name}, {test.loc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}